<template>
    <table class="table table-striped table-hover table-responsive-md text-center">
        <thead>
            <tr>
                <th>{{ $t("guestbook.name") }}</th>
                <th>{{ $t("guestbook.company") }}</th>
                <th>{{ $t("guestbook.from") }}</th>
                <th>{{ $t("guestbook.to") }}</th>
                <th>{{ $t("status.status") }}</th>
                <th></th>
            </tr>
        </thead>

        <tbody v-if="guestbookList.length">
            <tr v-for="guestbook in guestbookList" :key="guestbook.id">
                <td>{{ guestbook.guest_name }}</td>
                <td>{{ guestbook.company }}</td>
                <td>
                    <span v-if="guestbook.actual_from">
                        {{ $d(new Date(guestbook.actual_from), 'short') }}
                    </span>
                    <span v-else-if="guestbook.expected_from">
                        {{ $d(new Date(guestbook.expected_from), 'short') }}
                        <span class="fw-bold text-danger">*</span>
                    </span>
                    <span v-else>—</span>
                </td>
                <td>
                    {{ guestbook.actual_to ? $d(new Date(guestbook.actual_to), 'short') : "—" }}
                </td>
                <td>
                    <div
                        v-if="$store.getters.hasGatehousePerm('change_status_guestbook') && guestbook.status_name !== 'left'"
                        class="d-inline-flex align-items-center status_hover"
                        style="cursor: pointer;"
                        @click="openStatusModal(guestbook)"
                    >
                        <Icon :icon="guestbook.status_icon" class="status_icon me-1" />
                        <span>{{ $t("status.guestbook." + guestbook.status_name) }}</span>
                    </div>
                    <div v-else class="d-inline-flex align-items-center">
                        <Icon :icon="guestbook.status_icon" class="status_icon me-1" />
                        <span>{{ $t("status.guestbook." + guestbook.status_name) }}</span>
                    </div>
                </td>
                <td>
                    <button
                        class="btn btn-primary btn-sm me-2"
                        @click="goToGuestbookDetail(guestbook.id)"
                    >
                        <Icon icon="Search"></Icon>
                    </button>

                    <button
                        v-if="guestbook.status_name === 'reserved'"
                        class="btn btn-danger btn-sm"
                        @click="deleteGuestbook(guestbook.id)"
                    >
                        <Icon icon="Trash" />
                    </button>

                    <button v-else class="invisible" disabled>
                        <Icon icon="Trash"></Icon>
                    </button>
                </td>
            </tr>
        </tbody>

        <tbody v-else>
            <tr>
                <td colspan="6" class="text-center text-muted py-3">
                    {{ $t("guestbook.notFound") }}
                </td>
            </tr>
        </tbody>
    </table>

    <div v-if="totalCount > 0" class="d-flex justify-content-between mx-4">
        <Paginate
            :page-count="totalPages"
            :click-handler="p => $emit('page-change', p)"
            :prev-text="'«'"
            :next-text="'»'"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :active-class="'active'"
            :disabled-class="'disabled'"
        />

        <div class="flex-shrink-0">
            <select
                class="form-select form-select-sm"
                style="height: 40px;"
                :value="perPage"
                @change="$emit('per-page-change', Number($event.target.value))"
            >
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="50">50</option>
            </select>
        </div>
    </div>

    <GuestbookStatusesModal
        v-if="activeGuestbook"
        :guestbook="activeGuestbook"
        ref="statusModal"
        @updated="activeGuestbook = null; $emit('refresh')"
    />
</template>

<script>
import Icon from '@/components/Icon.vue';
import Paginate from 'vuejs-paginate-next';
import GuestbookStatusesModal from '@/components/GuestbookStatusesModal.vue';

export default {
    components: {
        Icon,
        Paginate,
        GuestbookStatusesModal
    },
    props: {
        items: {
            type: Array,
            required: true,
        },
        totalCount: {
            type: Number,
            default: 0,
        },
        page: {
            type: Number,
            default: 1,
        },
        perPage: {
            type: Number,
            default: 10,
        },
        statuses: {
            type: Array,
            default: null,
        }
    },
    data() {
        return {
            localStatuses: [],
            activeGuestbook: null,
        };
    },
    created() {
        if (this.statuses === null) this.getStatuses();
        else this.localStatuses = this.statuses;
    },
    methods: {
        getStatuses() {
            this.$store.getters.api.get(`/${this.$route.params.slug}/statuses`, {
                params: { model: "guestbook" }
            })
            .then(response => {
                this.localStatuses = response.data;
            });
        },
        goToGuestbookDetail(guestbookId) {
            this.$router.push({
                name: "guestbookDetailView",
                params: {
                    slug: this.$route.params.slug,
                    id: guestbookId,
                }
            });
        },
        deleteGuestbook(guestbookId) {
            const confirm = window.confirm(this.$t("utils.deleteQuestion"));
            if (!confirm) return;

            this.$store.getters.api.delete(`/${this.$route.params.slug}/guestbooks/${guestbookId}/delete`)
                .then(() => {
                    this.activeGuestbook = null;
                    this.$emit("refresh");
                })
                .catch(error => {
                    console.error("Error deleting guestbook.", error);
                });
        },
        openStatusModal(guestbook) {
            this.activeGuestbook = guestbook;
            this.$nextTick(() => {
                this.$refs.statusModal.show();
            })
        },
    },
    computed: {
        guestbookList() {
            return this.items;
        },
        totalPages() {
            return Math.ceil(this.totalCount / this.perPage);
        }
    },
};
</script>

<style scoped>
.status_icon {
    width: 25px;
    height: 25px;
}
</style>
